import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { DeleteConfirmationModal, DeleteIcon } from "components";
import { useDeleteSsoConfig } from "controller";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import toast from "react-hot-toast";

export const SsoList = ({
  ssoStateDetails,
  isUpdateSsoLoading,
  setSsoListShow,
  setPrimaryButtonText,
}: {
  ssoStateDetails: any;
  isUpdateSsoLoading: boolean;
  setSsoListShow: (show: boolean) => void;
  setPrimaryButtonText: (text: string) => void;
}) => {
  const theme = useTheme();

  const { reset } = useFormContext();

  const { mutateAsync: deleteSso, isLoading: isDeletingSso } =
    useDeleteSsoConfig();

  const [
    isSsoDomainDeleteConfirmationModalOpen,
    setIsSsoDomainDeleteConfirmationModalOpen,
  ] = useState(false);

  const [deleteLoadingId, setDeleteLoadingId] = useState<any>([]);
  const [deleteSsoDomainToBeDeletedId, setDeleteSsoDomainToBeDeletedId] =
    useState("");
  const [updateLoadingId, setUpdateLoadingId] = useState<any>([]);

  const onDeleteClick = async () => {
    const ssoConnectorId = deleteSsoDomainToBeDeletedId;
    try {
      setDeleteLoadingId([...deleteLoadingId, ssoConnectorId]);
      const response = await deleteSso(ssoConnectorId);
      setDeleteLoadingId(
        deleteLoadingId.filter((id: any) => id !== ssoConnectorId),
      );
      if (response?.success) {
        toast.success("SSO deleted successfully");
        setIsSsoDomainDeleteConfirmationModalOpen(false);
      }
    } catch (error) {
      toast.error("Unable to delete SSO at the moment.Try again later");
    }
  };

  const closeSsoDomainDeleteConfirmationModal = () =>
    setIsSsoDomainDeleteConfirmationModalOpen(false);

  const onEditSso = (data: any) => {
    reset({
      ssoConnectorId: data?.logto_connector_id || "",
      type: data?.type?.toUpperCase() || "OIDC",
      domain: data?.domain_name || "",
      ...(data?.type?.toUpperCase() === "OIDC"
        ? {
            clientId: data?.open_id || "",
            issuer: data?.application_id || "",
            clientSecret: data?.secret_value || "",
            expiry_date: data?.expiry_date || "",
            spEntityId: data?.secret_id || "",
          }
        : data?.type?.toUpperCase() === "SAML"
          ? {
              metadataType: data?.saml_metadata
                ? "xml"
                : data?.saml_metadata_url
                  ? "url"
                  : "unselected",
              ...(data?.saml_metadata
                ? {
                    metadata: data?.saml_metadata,
                  }
                : data?.saml_metadata_url
                  ? {
                      metadataUrl: data?.saml_metadata_url,
                    }
                  : {}),
            }
          : {}),
      // publicCertificate: data?.publicCertificate || "",
      // acsUrl: data?.acsUrl || null,
    });
    setPrimaryButtonText("Update");
    setSsoListShow(false);
  };

  return (
    <>
      {ssoStateDetails?.map((cellData: any) => {
        return (
          <Stack key={cellData?.id}>
            <Box
              sx={{
                borderBottom: "1px solid #E3E3E3",
                transition: "background-color 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#F0F4FC",
                },
              }}
              onClick={() => onEditSso(cellData)}
            >
              <Box
                padding={"5px 25px"}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <Typography variant="body-medium">
                    {cellData?.domain_name || "No Domain name"}
                  </Typography>
                </Box>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <Box
                    sx={{
                      cursor:
                        (isUpdateSsoLoading &&
                          updateLoadingId.includes(
                            cellData?.logto_connector_id,
                          )) ||
                        deleteLoadingId.includes(cellData?.logto_connector_id)
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    <IconButton
                      disabled={
                        (isUpdateSsoLoading &&
                          updateLoadingId.includes(
                            cellData?.logto_connector_id,
                          )) ||
                        deleteLoadingId.includes(cellData?.logto_connector_id)
                      }
                      onClick={(e: any) => {
                        e.stopPropagation();
                        setDeleteSsoDomainToBeDeletedId(
                          cellData?.logto_connector_id || "",
                        );
                        setIsSsoDomainDeleteConfirmationModalOpen(true);
                      }}
                    >
                      <DeleteIcon htmlColor={theme.palette.lightBg.high} />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Stack>
        );
      })}
      {isSsoDomainDeleteConfirmationModalOpen && (
        <DeleteConfirmationModal
          title="Delete Domain!"
          open={isSsoDomainDeleteConfirmationModalOpen}
          onClose={closeSsoDomainDeleteConfirmationModal}
          onSecondaryButtonClick={closeSsoDomainDeleteConfirmationModal}
          onPrimaryButtonClick={onDeleteClick}
          isLoading={isDeletingSso}
        />
      )}
    </>
  );
};
